import * as types from './mutation-types'

const mutation = {
  [types.CODES_GET_ALL](state, callcodes) {
    state.call_codes = callcodes
  },
  [types.CODES_GET_CUSTOMER](state, callcodes) {
    state.customer_call_codes = callcodes
  },
  [types.CODE_TYPES_GET_ALL](state, callcodeTypes) {
    state.call_codes_types = callcodeTypes
  },
  [types.SET_SELECTED_CODE](state, newValue) {
    state.selectedCallCode = newValue
  },
  [types.SAVE_CODE](state, code) {
    //create
    if (code.id === 0)
    {
      let newid = state.call_codes[state.call_codes.length -1].id ++
      code.id = newid;
      state.call_codes.push( code)
    }
    else {
      //update
      state.call_codes = [
        ...state.call_codes.filter(element => element.id !== code.id),
        code
      ]
    }
  }
}

export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/callcodes/mutations.js